import { render, staticRenderFns } from "./IcoPeople3Graph.vue?vue&type=template&id=35dd7b6e"
import script from "./IcoPeople3Graph.vue?vue&type=script&lang=js"
export * from "./IcoPeople3Graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports